import React, { useContext } from 'react';
import { Listing, TEASER_VERIFICATION } from 'models/Listing';
import { checkIsTierPlatinum, checkIsUrgent } from 'utils';
import PremiumListingCard from 'components/PremiumListingCard';
import DistressedListingCard from 'components/DistressedListingCard';
import ListingCard from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/ListingCard';
import AuthContext from 'providers/Auth/Auth.context';
import useOpenEnquire from 'hooks/useOpenEnquire';

type CorrectTierCardProps = {
  listing: Listing;
  updateListing: (listingId: string, updatedValues: Partial<Listing>) => void;
};

const CorrectTierCard: React.FC<CorrectTierCardProps> = ({
  listing,
  updateListing,
}) => {
  const { _id, tier, type, teaserVerification, enableTeaser } = listing;

  const { isLoggedIn } = useContext(AuthContext);

  const openEnquire = useOpenEnquire();

  const CorrectTierCard = checkIsTierPlatinum(tier)
    ? PremiumListingCard
    : checkIsUrgent(type)
    ? DistressedListingCard
    : ListingCard;

  const needsToBeLoggedIn =
    !isLoggedIn &&
    teaserVerification === TEASER_VERIFICATION.WITH_EMAIL_VERIFICATION;

  const isTeaserEnabled = enableTeaser && !needsToBeLoggedIn;

  return (
    <CorrectTierCard
      key={_id}
      listing={listing}
      onWatchedListed={(isWatchlisted) => updateListing(_id, { isWatchlisted })}
      onEnquire={(listingId, redirectLink) =>
        openEnquire(listingId, isTeaserEnabled, redirectLink)
      }
    />
  );
};

export default CorrectTierCard;
